import React, {FC} from 'react';
import cn from 'classnames';

import {Card} from '../../components/Card/Card';
import {Footer} from '../../components/Footer/Footer';
import {Header} from '../../components/Header/Header';
import {Question} from '../../components/Question/Question';
import {OFFER_ITK, OFFER_RNKO, OFFER_T2} from '../../config/routes';

import {Connect} from './Connect/Connect';
import {Cover} from './Cover/Cover';
import {HowToUse} from './HowToUse/HowToUse';
import {Structure} from './Structure/Structure';

import cls from './Index.module.scss'

const Index: FC = () => (
    <>
        <Header/>
        <Cover/>
        <div className={cls.wrapper}>
            <div className={cn(['content', cls.blocks])}>

                <Structure/>

                <HowToUse/>

                <Connect/>

                <Card color={'white'}>
                    <h2>Остались вопросы? ответим!</h2>
                    <div className={cls.columns}>
                        <div className={cls.column}>
                            <Question color={'gray'} question={'Какие возможности дает приложение VITA?'} answer={
                                <ol>
                                    <li>Скачайте приложение VITA в&nbsp;App Store или Google Play
                                    </li>
                                    <li>Зарегистрируйтесь и&nbsp;пройдите анкетирование
                                    </li>
                                    <li>По итогу вам будет предложен для прохождения список лабораторных и инструментальных исследований
                                    </li>
                                    <li>
                                        По&nbsp;итогу вам будет предложен для прохождения список лабораторных и&nbsp;инструментальных исследований
                                    </li>
                                </ol>
                            }/>
                            <Question color={'gray'}
                                      question={<>Являются&nbsp;ли профессионалами специалисты, оказывающие консультации?</>}
                                      answer={<>Все сотрудники сервиса&nbsp;&mdash; дипломированные специалисты, которые проходят строгий отбор и&nbsp;обладают практическим опытом работы в&nbsp;юриспруденции.</>}/>
                        </div>
                        <div className={cls.column}>
                            <Question color={'gray'} question={'Как получить консультацию нутрициолога?'} answer={
                                <ol>
                                    <li>Предварительно скачайте приложение VITA и&nbsp;пройдите анкетирование. Это поможет специалисту уже в&nbsp;ходе первой консультации дать вам развернутые рекомендации.
                                    </li>
                                    <li>Для проведения консультации зайдите на&nbsp;официальную страницу компании FTS по&nbsp;ссылке <a href={'https://fintechservice.group/consultation'}
                                                              target={'_blank'}
                                                              rel={'noreferrer'}>https://fintechservice.group/consultation</a>
                                    </li>
                                    <li>
                                        Заполните форму и&nbsp;дождитесь ответа менеджера
                                    </li>
                                    <li>
                                        Менеджер согласует с&nbsp;вами дату и&nbsp;время проведения консультации нутрициолога
                                    </li>
                                    <li>
                                        В&nbsp;обозначенное время с&nbsp;вами свяжется специалист для оказания услуги
                                    </li>
                                </ol>
                            }/>
                            <Question color={'gray'} question={'Как отключить услугу?'} answer={
                                <>
                                    Отключить услугу вы&nbsp;можете на&nbsp;t2.ru в&nbsp;<a href={'https://t2.ru/lk'} target={'_blank'}
                                                                             rel={'noreferrer'}>личном кабинете</a> или
                                    в&nbsp;мобильном приложении t2&nbsp;в разделе &laquo;Услуги&raquo;.
                                </>
                            }/>
                        </div>
                    </div>
                </Card>

                <Card color={'gray'}>
                    <div>Услуга &laquo;Мобильная защита&raquo; (15&nbsp;руб./сут., включая налоги) предоставляется ООО &laquo;ИТ&nbsp;Консул&raquo; на
                        условиях оферты. Оплата осуществляется переводом с&nbsp;лиевого счета абонента t2&nbsp;на условиях оферты
                        и&nbsp;условиях оферты ООО &laquo;РНКО Единая касса&raquo;
                    </div>
                    <ul>
                        <li><a href={OFFER_ITK}>Правила абонентского обслуживания ООО &laquo;ИТ&nbsp;Консул&raquo;</a></li>
                        <li><a href={OFFER_T2}>Оферта&nbsp;t2</a></li>
                        <li><a href={OFFER_RNKO}>Оферта ООО &laquo;РНКО Единая касса&raquo;</a></li>
                    </ul>
                </Card>
            </div>
        </div>

        <Footer/>

    </>
);

export default Index;



